// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App($app_id: uuid!) {
  apps_apps_by_pk(id: $app_id) {
    id
    name: metadata(path: "name")
    logo: metadata(path: "logo")
    description: metadata(path: "description")
    website: metadata(path: "website")
    properties: metadata(path: "properties")
    connection: metadata(path: "connection")
    sync: metadata(path: "sync")
    automations: metadata(path: "automations")
    launchers: metadata(path: "launchers")
    features: metadata(path: "features")
    tags: metadata(path: "tags")
    companies {
      id
      status
      properties: metadata(path: "properties")
    }
    # TODO: maybe fetch connections at point of use?
    connections(where: { status: { _neq: deleted } }) {
      id
      display_name
      status
      app_id
      xid
      created_at
      connected_at
      updated_at
      # TODO: use from the parent instead
      app {
        id
        connection: metadata(path: "connection")
      }
      user {
        id
        vaxiom_person {
          id
          first_name
          last_name
        }
      }
      resources {
        id
        resource_id
        status
        location {
          _id
          name
        }
      }
      providers {
        id
        provider_id
      }
    }
  }
}

`